import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrIcon } from "../../icons";
import { GrStack } from "../../layout";
import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import classNames from "classnames";
const StyledChip = styled("div")(({ size, color, variant, shape, disabled }) => {
    return {
        display: "inline-flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        border: "none",
        gap: "2px",
        userSelect: "none",
        borderRadius: shape === "circle" ? "26px" : "6px",
        ...(size === "large" && {
            maxHeight: "30px",
            padding: `6px ${shape === "circle" ? "10px" : "8px"}`,
            ...typography["Content.Subtitle04"],
        }),
        ...(size === "medium" && {
            maxHeight: "24px",
            padding: `4px ${shape === "circle" ? "8px" : "6px"}`,
            ...typography["Content.Caption02"],
        }),
        ...(size === "small" && {
            maxHeight: "18px",
            padding: `2px ${shape === "circle" ? "6px" : "4px"}`,
            ...typography["Content.Caption02"],
        }),
        ...(variant === "plain" && {
            backgroundColor: palette.grey010,
            ...(color === "primary" && {
                color: palette.blue050,
                "svg path": {
                    fill: palette.blue050,
                },
            }),
            ...(color === "grey" && {
                color: palette.grey070,
                "svg path": {
                    fill: palette.grey040,
                },
            }),
            ...(color === "red" && {
                color: palette.red050,
                "svg path": {
                    fill: palette.red050,
                },
            }),
            ...(color === "orange" && {
                color: palette.orange050,
                "svg path": {
                    fill: palette.orange050,
                },
            }),
            ...(color === "green" && {
                color: palette.green050,
                "svg path": {
                    fill: palette.green050,
                },
            }),
            ...(color === "purple" && {
                color: palette.purple060,
                "svg path": {
                    fill: palette.purple060,
                },
            }),
            ...(color === "navy" && {
                color: palette.darkNavy040,
                "svg path": {
                    fill: palette.darkNavy040,
                },
            }),
        }),
        ...(variant === "soft" && {
            ...(color === "primary" && {
                color: palette.blue050,
                backgroundColor: palette.blue015,
                "svg path": {
                    fill: palette.blue050,
                },
            }),
            ...(color === "grey" && {
                color: palette.grey070,
                backgroundColor: palette.grey020,
                "svg path": {
                    fill: palette.grey050,
                },
            }),
            ...(color === "red" && {
                color: palette.red050,
                backgroundColor: palette.red015,
                "svg path": {
                    fill: palette.red050,
                },
            }),
            ...(color === "orange" && {
                color: palette.orange050,
                backgroundColor: palette.orange015,
                "svg path": {
                    fill: palette.orange050,
                },
            }),
            ...(color === "green" && {
                color: palette.green050,
                backgroundColor: palette.green015,
                "svg path": {
                    fill: palette.green050,
                },
            }),
            ...(color === "purple" && {
                color: palette.purple060,
                backgroundColor: palette.purple015,
                "svg path": {
                    fill: palette.purple060,
                },
            }),
            ...(color === "navy" && {
                color: palette.darkNavy040,
                backgroundColor: palette.darkNavy010,
                "svg path": {
                    fill: palette.darkNavy040,
                },
            }),
        }),
        ...(variant === "outlined-soft" && {
            ...(color === "primary" && {
                color: palette.blue050,
                backgroundColor: palette.blue010,
                border: `1px solid ${palette.blue020}`,
                "svg path": {
                    fill: palette.blue050,
                },
            }),
            ...(color === "grey" && {
                color: palette.grey070,
                backgroundColor: palette.grey010,
                border: `1px solid ${palette.grey025}`,
                "svg path": {
                    fill: palette.grey050,
                },
            }),
            ...(color === "red" && {
                color: palette.red050,
                backgroundColor: palette.red010,
                border: `1px solid ${palette.red020}`,
                "svg path": {
                    fill: palette.red050,
                },
            }),
            ...(color === "orange" && {
                color: palette.orange050,
                backgroundColor: palette.orange010,
                border: `1px solid ${palette.orange020}`,
                "svg path": {
                    fill: palette.orange050,
                },
            }),
            ...(color === "green" && {
                color: palette.green050,
                backgroundColor: palette.green010,
                border: `1px solid ${palette.green020}`,
                "svg path": {
                    fill: palette.green050,
                },
            }),
            ...(color === "purple" && {
                color: palette.purple060,
                backgroundColor: palette.purple010,
                border: `1px solid ${palette.purple020}`,
                "svg path": {
                    fill: palette.purple060,
                },
            }),
            ...(color === "navy" && {
                color: palette.darkNavy040,
                backgroundColor: palette.darkNavy005,
                border: `1px solid ${palette.darkNavy020}`,
                "svg path": {
                    fill: palette.darkNavy040,
                },
            }),
        }),
        ...(variant === "outlined" && {
            backgroundColor: palette.white,
            ...(color === "primary" && {
                color: palette.blue050,
                border: `1px solid ${palette.blue040}`,
                "svg path": {
                    fill: palette.blue050,
                },
            }),
            ...(color === "grey" && {
                color: palette.grey070,
                border: `1px solid ${palette.grey025}`,
                "svg path": {
                    fill: palette.grey050,
                },
            }),
            ...(color === "red" && {
                color: palette.red050,
                border: `1px solid ${palette["negative-secondary"]}`,
                "svg path": {
                    fill: palette.red050,
                },
            }),
            ...(color === "orange" && {
                color: palette.orange050,
                border: `1px solid ${palette["warning-secondary"]}`,
                "svg path": {
                    fill: palette.orange050,
                },
            }),
            ...(color === "green" && {
                color: palette.green050,
                border: `1px solid ${palette["positive-secondary"]}`,
                "svg path": {
                    fill: palette.green050,
                },
            }),
            ...(color === "purple" && {
                color: palette.purple060,
                border: `1px solid ${palette.purple040}`,
                "svg path": {
                    fill: palette.purple060,
                },
            }),
            ...(color === "navy" && {
                color: palette.darkNavy040,
                border: `1px solid ${palette.darkNavy040}`,
                "svg path": {
                    fill: palette.darkNavy040,
                },
            }),
        }),
        ...(variant === "solid" && {
            color: palette.white,
            "svg path": {
                fill: palette.white,
            },
            ...(color === "primary" && {
                backgroundColor: palette.blue050,
            }),
            ...(color === "grey" && {
                backgroundColor: palette.grey080,
            }),
            ...(color === "red" && {
                backgroundColor: palette.red050,
            }),
            ...(color === "orange" && {
                backgroundColor: palette.orange050,
            }),
            ...(color === "green" && {
                backgroundColor: palette.green050,
            }),
            ...(color === "purple" && {
                backgroundColor: palette.purple060,
            }),
            ...(color === "navy" && {
                backgroundColor: palette.darkNavy040,
            }),
        }),
        ...(disabled && {
            background: palette.grey020,
            color: palette.grey030,
            border: `1px solid ${palette.grey025}`,
            svg: {
                path: {
                    fill: palette.grey025,
                },
            },
            ...((variant === "outlined" || variant === "outlined-soft") && {
                border: `1px solid ${palette.grey025}`,
            }),
        }),
    };
});
const StyledGrIconWrapper = styled("div")(() => {
    return {
        cursor: "pointer",
    };
});
export function GrChip(props) {
    const { size, color, variant, shape, label, onDelete, onClick, leftIconType, disabled, className, ...others } = props;
    return (_jsxs(StyledChip, { className: classNames("GrChip", className), size: size, color: color, variant: variant, shape: shape, onClick: onClick, disabled: disabled, ...others, children: [leftIconType && _jsx(GrIcon, { size: 14, type: leftIconType }), _jsx(GrStack, { padding: "0 2px", children: label }), onDelete && (_jsx(StyledGrIconWrapper, { onClick: onDelete, children: _jsx(GrIcon, { size: 14, type: "circle-x-filled" }) }))] }));
}
//# sourceMappingURL=GrChip.js.map